import { render } from "./AdvicesComponent.vue?vue&type=template&id=122b4882&scoped=true"
import script from "./AdvicesComponent.vue?vue&type=script&lang=js"
export * from "./AdvicesComponent.vue?vue&type=script&lang=js"

import "./AdvicesComponent.vue?vue&type=style&index=0&id=122b4882&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122b4882"]])

export default __exports__